export default __webpack_public_path__ + "static/media/icon-out-of-zone-notification.799c541d.svg";